var map = {
	"./bo6/modes-and-maps.json": [
		7454,
		454
	],
	"./bo7/modes-and-maps.json": [
		5839,
		839
	],
	"./haloInfinite/modes-and-maps.json": [
		7001,
		1
	],
	"./mw4/modes-and-maps.json": [
		1231,
		231
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9808;
module.exports = webpackAsyncContext;